export const LEAGUE_GAMES = {
  MAGIC_THE_GATHERING: {
    label: "Magic: The Gathering",
    shortLabel: "Magic",
    description: "Standard, Modern, Commander, Limited, and more",
    formats: [
      "Standard",
      "Modern",
      "Pioneer",
      "Legacy",
      "Vintage",
      "Commander",
      "Pauper",
      "Draft",
      "Sealed",
      "Other",
    ],
  },
  RIFTBOUND: {
    label: "Riftbound",
    shortLabel: "Riftbound",
    description: "Constructed and limited Riftbound league play",
    formats: ["Constructed", "Draft", "Sealed", "Other"],
  },
  DRAGON_BALL_MASTERS: {
    label: "Dragon Ball Masters",
    shortLabel: "Dragon Ball",
    description: "Constructed and limited Dragon Ball Masters league play",
    formats: ["Constructed", "Limited"],
  },
} as const;

export type LeagueGame = keyof typeof LEAGUE_GAMES;

export const DEFAULT_LEAGUE_GAME: LeagueGame = "MAGIC_THE_GATHERING";

export const getLeagueGame = (game?: string | null): LeagueGame =>
  game && Object.prototype.hasOwnProperty.call(LEAGUE_GAMES, game)
    ? (game as LeagueGame)
    : DEFAULT_LEAGUE_GAME;

export const getLeagueGameLabel = (game?: string | null): string =>
  LEAGUE_GAMES[getLeagueGame(game)].label;

export const getLeagueFormats = (game?: string | null): readonly string[] =>
  LEAGUE_GAMES[getLeagueGame(game)].formats;
